import styled from '@emotion/styled';
import PropTypes from 'prop-types';
import React from 'react';

import { dateTimeSlashesFormat, formatDate } from 'App/services/DateService';
import { WysiwygField } from 'Shared/form/WysiwygField';
import contentGroupPropType from '../../types/contentGroupPropType';
import contentVersionPropType from '../../types/contentVersionPropType';
import { contentTitles } from '../constants';
import getGroupScrollId from '../utils/getGroupScrollId';
import TemplateDisplayWithClipboard from './TemplateDisplayWithClipboard';

const ContentVersionHeaderStyle = styled.div`
    display: flex;
    justify-content: space-between;
`;

const ContentLibraryEditContentVersion = ({ contentGroup, contentVersion, fieldName, disabled }) => {
    return (
        <div id={getGroupScrollId(contentVersion)} className="form-group">
            <ContentVersionHeaderStyle>
                <div>
                    <strong>{contentTitles[contentGroup.type][contentVersion.label]} | </strong>
                    <TemplateDisplayWithClipboard templateText={`${contentGroup.label}_${contentVersion.label}`} />
                </div>
                <div>
                    {contentVersion.updatedByUser ? (
                        <>
                            {contentVersion.updatedByUser.lastName}, {contentVersion.updatedByUser.firstName}
                            {' - '}
                            {formatDate(contentVersion.updatedOn, dateTimeSlashesFormat)}
                        </>
                    ) : (
                        '--'
                    )}
                </div>
            </ContentVersionHeaderStyle>

            <WysiwygField disabled={disabled} fieldName={fieldName} />
        </div>
    );
};

ContentLibraryEditContentVersion.propTypes = {
    contentGroup: contentGroupPropType.isRequired,
    contentVersion: contentVersionPropType.isRequired,
    fieldName: PropTypes.string.isRequired,
    disabled: PropTypes.bool,
};

ContentLibraryEditContentVersion.defaultProps = {
    disabled: false,
};

export default ContentLibraryEditContentVersion;
